import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ProgressSpinner } from 'primeng/progressspinner';
import { RouterOutlet } from '@angular/router';
import { AcceptTeamInvitationsService } from './shared/accept-team-invations/services/accept-team-invitations.service';
import {
  FaIconLibrary,
  FontAwesomeModule,
} from '@fortawesome/angular-fontawesome';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { environment } from '../environments/environment.development';
import { InAppSupportService } from './shared/services/support/in-app-support.service.ts';
import { UserBehaviorMonitoringService } from '@tokenbox/services';

@Component({
  selector: 'dt-root',
  imports: [
    ProgressSpinner,
    RouterOutlet,
    FontAwesomeModule,
    ConfirmDialogModule,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {
  title = 'design-tokens.io';

  private acceptTeamInvitationsService = inject(AcceptTeamInvitationsService);
  private fontAwesomeLibrary = inject(FaIconLibrary);
  private inAppSupportService = inject(InAppSupportService);

  constructor() {
    void this.acceptTeamInvitationsService.showPendingInvitationsDialog();
    this.fontAwesomeLibrary.addIconPacks(far, fas /*, fab*/);
    setTimeout(() => {
      this.inAppSupportService.initializeChat(
        environment.support.crisp.websiteId,
      );
    }, 2000);
  }
}
